// This file is generated by pnpm icons:generate. Do not edit.

import {EnvelopeOpen_Stroke2_Corner0_Rounded as CanonicalEnvelope_Open_Stroke2_Corner0_Rounded} from './Envelope'

/** @deprecated Import EnvelopeOpen_Stroke2_Corner0_Rounded from `#/components/icons/Envelope` instead. */
export const Envelope_Open_Stroke2_Corner0_Rounded =
  CanonicalEnvelope_Open_Stroke2_Corner0_Rounded
